module.exports = __webpack_public_path__ + "static/media/WorkSpouses.3aa15b0b.png";